import React from 'react';

import api     from '../../../../../../api';
import Context from '../../../../../../context';

import { useTranslation } from 'react-i18next';
import {
  CustomView,
  CustomModal,
  CustomButton2,
  CustomCheckBox,
} from '../../../../../../components';

import './index.scss';

const ExcelJS = require('exceljs');

const ExportExcel: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const {
    showModal,
    isLoading,
    setShowModal,
    getAllWithdrawal,
    selectedWithdrawals,
  } = React.useContext(Context.WithdrawalScreen);
  const [changeStatus, setChangedStatus] = React.useState<boolean>(false);

  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function exportExcelFile(): Promise<void> {
    const workBook = new ExcelJS.Workbook({
      useStyle: true,
    });
    const sheet = workBook.addWorksheet("My Sheet");

    sheet.columns = [
      { header: "Destination Iban Number (Variz Be Sheba)", key: "shabaId", width: 40 },
      { header: "Transfer Amount (Mablagh)", key: "amount", width: 15 },
      { header: "Owner Name (Name e Sahebe Seporde)", key: "name", width: 20},
      { header: "Destination Note (Sharh)", key: "description", width: 15 },
      { header: "pay Id(Shenaseh variz)", key: "trackingCode", width: 15 },
      { header: "Please do not remove this first row. (Lotfan radife nokhost ra paak nafarmayid.)", key: "des", width: 15 },
    ];

    getAllWithdrawal?.data?.result?.docs
      ?.filter((item: any) => selectedWithdrawals.includes(item._id))
      ?.map((item: any, index: number) => {
        const row = sheet.addRow({
          name: namePiker(item),
          amount: String(item?.amount)+'0',
          shabaId: 'IR' + item?.shabaId,
          description: 'واریزی',
          trackingCode: item?.trackingCode,
          des: undefined,
        });
      });

    workBook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheet.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `exported-file-${new Date().getTime()}.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
    if ( changeStatus ) {
      await api.put.administrator.sendToBankManyPayToDriver({withdrawalId:selectedWithdrawals});
      getAllWithdrawal.refetch()
    }
    setShowModal!('NONE');
  }

  function namePiker(item: any): string {
    switch(item?.type) {
      case 'ADMIN'  : return `${item?.userId?.firstName } ${item?.userId?.lastName }`;
      case 'DRIVER' : return `${item?.driver?.firstName } ${item?.driver?.lastName }`;
      case 'COMPANY': return `${item?.company?.firstName} ${item?.company?.lastName}`;
      default: return '';
    }
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id='school-approve-modal-container'>
      <CustomModal onClose={() => setShowModal!('NONE')} open={showModal === 'EXPORT_EXCEL'}>
        <CustomView.Container className='approve-form-content'>
          <h6 style={{display:'flex' , justifyContent:'center'}}>خروجی اکسل</h6>
          <CustomView.Row className='radio-button-group'>
            <CustomView.Column >
              <CustomCheckBox isChecked={changeStatus} onChecked={()=>setChangedStatus(!changeStatus)} label={`تغییر وضعیت به "ارسال شده به بانک"`}/>
              </CustomView.Column>
          </CustomView.Row>
          <br />
          <CustomView.Row className='form-row'>
            <CustomView.Column large={3} medium={4} small={6} className='form-colum'>
              <CustomButton2 isLoading={isLoading} onClick={() => setShowModal!('NONE')} title={t('cancel')} type='danger'/>
            </CustomView.Column>
            <CustomView.Column large={3} medium={4} small={6} className='form-colum'>
              <CustomButton2 isLoading={isLoading} onClick={exportExcelFile} title={t('approve')} type={'primary'}/>
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};
export default ExportExcel;
